// extracted by mini-css-extract-plugin
export var cardWrapper = "_61-0";